import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

// Schoolasium DS typography: Roboto for UI, JetBrains Mono for code.
// Self-hosted rather than loaded from a CDN so the flasher renders correctly
// offline and behind the tunnel.
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import "@fontsource-variable/jetbrains-mono";

// Tokens must load before component styles — everything in styles.css is a
// var() reference into this file.
import "./tokens.css";
import "./styles.css";

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root element #root is missing from index.html.");
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
